var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#EAEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_9845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5C21.933 15.5 23.5 13.933 23.5 12C23.5 10.067 21.933 8.5 20 8.5C18.067 8.5 16.5 10.067 16.5 12C16.5 13.933 18.067 15.5 20 15.5Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 21.4999H23.9999V18.6209L30.1209 12.4999L28.5919 10.9709L22.1929 16.4999H17.8069L11.4079 10.9709L9.87891 12.4999L15.9999 18.6209V21.4999Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2266 25.081L15.6996 23.062L13.7996 25.6C13.6209 25.8385 13.5173 26.1248 13.502 26.4224C13.4867 26.72 13.5603 27.0154 13.7136 27.271L16.7136 32.271L18.6616 31.1L16.8046 26.59L18.2266 25.081Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7729 25.081L24.2999 23.062L26.1999 25.6C26.3786 25.8385 26.4822 26.1248 26.4975 26.4224C26.5128 26.72 26.4392 27.0154 26.2859 27.271L23.2859 32.271L21.3379 31.1L23.1949 26.59L21.7729 25.081Z",
    fill: "#0236C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_9845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.59d4adffa31a31ed82eba341f75281a9.svg";
export { ForwardRef as ReactComponent };